import { useEffect, useRef, type ReactNode } from 'react';

interface BottomSheetProps {
  title: string;
  children: ReactNode;
  onDismiss: () => void;
}

/** Bottom sheet met overlay; schuift omhoog in 200 ms (of instant bij reduced motion). */
export function BottomSheet({ title, children, onDismiss }: BottomSheetProps) {
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    panelRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onDismiss();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onDismiss]);

  return (
    <div className="sheet-overlay" onClick={onDismiss}>
      <div
        ref={panelRef}
        className="sheet"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
        onClick={(event) => event.stopPropagation()}
      >
        <h2 className="sheet__title">{title}</h2>
        {children}
      </div>
    </div>
  );
}
